import { render, staticRenderFns } from "./skeleton.vue?vue&type=template&id=08918107"
import script from "./skeleton.vue?vue&type=script&lang=js"
export * from "./skeleton.vue?vue&type=script&lang=js"
import style0 from "./skeleton.vue?vue&type=style&index=0&id=08918107&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports